<template>
  <div class="directory-list">
    <directory-tree :edit="edit" :drag-over-id="dragOverId" :statistic="statistic" @on-edit="onEdit" @on-drop="onDrop"
                    :active-dir-id="activeDirId"
                    @on-delete="onDelete" @on-click="onClick" @on-collapse="onCollapse" @on-change="onChange" :data="dirData">
    </directory-tree>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import { mapActions, mapState } from 'vuex';
import AppTag from '@/portal-components/tag/tag-list';
import { getDirectoryStructure, setDirectoryFlatStructure, setDirectoryStructure } from '@/utils/directory';
import DirectoryProxy from '@/store/proxies/directory-proxy';
import DirectoryTree from './directory-tree';


export default {
  name: 'AppDirectory',
  components: {
    DirectoryTree,
    draggable,
    AppTag,
  },
  props: {
    edit: {
      type: Boolean,
      default() {
        return false;
      },
    },
    activeDirId: [String, Number],
  },
  data() {
    return {
      dragOverId: { id: null },
      companyName: '',
      currentDefaultDir: '',
      rootActive: true,
      recentUploadDirActive: false,
      inProgressDirActive: false,
      dirData: [],
      dirLookup: {},
    };
  },
  computed: {
    ...mapState({
      total_amount_wait_approval: state => state.appStatistics.total_amount_wait_approval,
      statistic: state => state.appStatistics.directories,
      totalSuspectStatistic: state => state.appStatistics.totalSuspectStatistic,
      totalDebtStatistic: state => state.appStatistics.totalDebtStatistic,
      totalReceivableStatistic: state => state.appStatistics.totalReceivableStatistic,
      inProgressCount: state => state.inProgressInvoiceList.length,
      importedInvoicesCount: (state) => {
        if (state.recentImportedInvoices) {
          return state.recentImportedInvoices.length;
        }
        return 0;
      },
    }),
  },
  created() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.companyName = currentUser.company.name;
    new DirectoryProxy().getDirTree().then(({ structure }) => {
      setDirectoryStructure(structure);
      this.loadAppDirectory();
      this.$bus.on('refresh-app-directory', this.loadAppDirectory);
    });
  },
  mounted() {
    this.loadAppDirectory();
    this.$bus.on('refresh-app-directory', this.loadAppDirectory);
  },
  beforeDestroy() {
    this.$bus.off('refresh-app-directory', this.loadAppDirectory);
  },
  methods: {
    ...mapActions(['moveInvoiceToDir', 'getStatistics']),
    loadAppDirectory(dirData) {
      this.dirData = dirData || getDirectoryStructure();
      this.populateDirectoryData(this.dirData);
      setDirectoryStructure(this.dirData);
      setDirectoryFlatStructure(this.dirLookup);
    },
    onDrop(data) {
      const payload = {
        parent_id: parseInt(data.directoryId, 0),
        invoices: new Set([parseInt(data.invoiceId, 0)]),
      };
      this.moveInvoiceToDir(payload);
    },
    onClick({ $event, dirItem }) {
      if (this.edit) {
        return;
      }
      this.$emit('on-click', { $event, dirItem });
    },
    onEdit(dirItem) {
      this.$modal.show('create-directory-modal', { model: dirItem });
    },
    onDelete(dirItem) {
      const parentDir = this.dirLookup[dirItem.parentId];
      if (!parentDir) {
        this.removeItemFromList(this.dirData, dirItem.id);
      } else {
        this.removeItemFromList(this.dirLookup[dirItem.parentId].children, dirItem.id);
      }
      setDirectoryStructure(this.dirData);
      setDirectoryFlatStructure(this.dirLookup);
    },
    removeItemFromList(list, id) {
      const idx = list.findIndex(item => item.id === id);
      if (idx > -1) {
        list.splice(idx, 1);
      }
    },
    onChange(dirData) {
      this.populateDirectoryData(dirData);
      setDirectoryStructure(dirData);
      setDirectoryFlatStructure(this.dirLookup);
      this.$emit('on-change', JSON.parse(JSON.stringify(dirData)));
    },
    onCollapse(node, isShow) {
      this.dirLookup[node.id].expand = isShow;
    },
    populateDirectoryData(data) {
      const rootDir = {
        id: 0,
        name: 'root',
        children: data,
      };
      this.dirLookup = {};
      const dirList = this.browseDirectory(rootDir).filter(d => d.id !== 0);
      dirList.forEach((item) => {
        this.dirLookup[item.id] = item;
        this.dirLookup[item.id].descendant = this.browseDirectory(item)
          .filter(i => i.id !== item.id).map(i => i.id);
      });
    },
    browseDirectory(dir, cb) {
      const stack = [
        dir,
      ];
      const result = [];
      let current;
      while (stack.length > 0) {
        current = stack.pop();
        result.push(current);
        if (cb) {
          cb(current);
        }
        // eslint-disable-next-line no-loop-func
        current.children.forEach((item) => {
          item.parentId = current.id;
          stack.push(item);
        });
      }
      return result;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/directory-list/index.vue